import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=417b5bb1&"
import script from "./BaseSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports